export enum MenuItem {
    login,
    home,
    tonnage,
    toll,
    statements,
    users,
    customer,
    site,
    repository,
    report,
    billing,
    forgetPassword
}
export const MenuItemName = new Map<number, string>([
    [MenuItem.login, 'login'],
    [MenuItem.home, 'home'],
    [MenuItem.tonnage, 'tonnage'],
    [MenuItem.toll, 'toll'],
    [MenuItem.statements, 'statements'],
    [MenuItem.users, 'users'],
    [MenuItem.customer, 'customer'],
    [MenuItem.site, 'site'],
    [MenuItem.repository, 'repository'],
    [MenuItem.report, 'report'],
    [MenuItem.billing, 'billing'],
    [MenuItem.forgetPassword, 'forgetpassword'],
]);

export const MenuItemPath = new Map<number, string>([
    [MenuItem.login, 'login'],
    [MenuItem.home, 'home'],
    [MenuItem.tonnage, 'tonnage'],
    [MenuItem.toll, 'toll'],
    [MenuItem.statements, 'statements'],
    [MenuItem.users, 'users'],
    [MenuItem.customer, 'customer'],
    [MenuItem.site, 'site'],
    [MenuItem.repository, 'repository'],
    [MenuItem.report, 'report'],
    [MenuItem.billing, 'billing'],
    [MenuItem.forgetPassword, 'forgetpassword'],
]);
export const MenuItemRoute = new Map<number, string>([
    [MenuItem.login, '/' + MenuItemPath.get(MenuItem.login)],
    [MenuItem.home, '/' + MenuItemPath.get(MenuItem.home)],
    [MenuItem.tonnage, '/' + MenuItemPath.get(MenuItem.tonnage)],
    [MenuItem.toll, '/' + MenuItemPath.get(MenuItem.toll)],
    [MenuItem.statements, '/' + MenuItemPath.get(MenuItem.statements)],
    [MenuItem.users, '/' + MenuItemPath.get(MenuItem.users)],
    [MenuItem.customer, '/' + MenuItemPath.get(MenuItem.customer)],
    [MenuItem.site, '/' + MenuItemPath.get(MenuItem.site)],
    [MenuItem.repository, '/' + MenuItemPath.get(MenuItem.repository)],
    [MenuItem.report, '/' + MenuItemPath.get(MenuItem.report)],
    [MenuItem.billing, '/' + MenuItemPath.get(MenuItem.billing)],
    [MenuItem.forgetPassword, '/' + MenuItemPath.get(MenuItem.forgetPassword)],
]);

export const MenuItemIcon = new Map<number, string>([
    [MenuItem.login, ''],
    [MenuItem.home, 'home'],
    [MenuItem.tonnage, 'directions_boat'],
    [MenuItem.toll, 'directions_railway'],
    [MenuItem.statements, 'history'],
    [MenuItem.users, 'supervisor_account'],
    [MenuItem.customer, 'location_city'],
    [MenuItem.site, 'place'],
    [MenuItem.repository, 'ballot'],
    [MenuItem.report, 'description'],
    [MenuItem.billing, 'receipt'],
]);
